module.exports = __webpack_public_path__ + "static/media/styled-components.9ceedb83.svg";